/**
 * هم‌خوان با `IranMobileNormalizer::fromNationalInput` در بک‌اند.
 * خروجی: ۱۰ رقم ملی بدون صفر اول، الگوی `9xxxxxxxxx`.
 */
export function normalizeNationalMobileDigits(raw: string): string | null {
  let d = raw.replace(/\D/g, '');
  if (!d) return null;
  if (d.startsWith('98') && d.length >= 12) {
    d = d.slice(2);
  }
  if (/^09\d{9}$/.test(d)) return d.slice(1);
  if (/^9\d{9}$/.test(d)) return d;

  return null;
}
